export default {
      id: "common__locator-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#common__locator",
      toString: function () {
        return this.url;
      }
    }